// get color names from
// http://chir.ag/projects/name-that-color/

export const white = "#FFFFFF"
export const black = "#000000"
export const blazeOrange = "#FF6B00"
export const dustyGray = "#979797"
export const silver = "#CCCCCC"
export const wildSand = "#F4F4F4"
